"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConverterUtils_1 = require("../../../core/utils/ConverterUtils");

var NChangedWinThreshold_1 = require("../model/NChangedWinThreshold");

var NChangedWinThresholdConverter_1 = require("./NChangedWinThresholdConverter");
/**
 * @author Tomas Leity
 */


var NChangedWinThresholdConverterImpl =
/*#__PURE__*/
function (_NChangedWinThreshold) {
  _inherits(NChangedWinThresholdConverterImpl, _NChangedWinThreshold);

  function NChangedWinThresholdConverterImpl() {
    _classCallCheck(this, NChangedWinThresholdConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinThresholdConverterImpl).apply(this, arguments));
  }

  _createClass(NChangedWinThresholdConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NChangedWinThreshold_1.NChangedWinThreshold(NChangedWinThreshold_1.NChangedWinThreshold.schema.promoSales.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.promoSales)), NChangedWinThreshold_1.NChangedWinThreshold.schema.promoSalesOld.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.promoSalesOld)), NChangedWinThreshold_1.NChangedWinThreshold.schema.promoSalesAbsTh.valueOf(source.promoSalesAbsTh), NChangedWinThreshold_1.NChangedWinThreshold.schema.promoSalesRelTh.valueOf(source.promoSalesRelTh), NChangedWinThreshold_1.NChangedWinThreshold.schema.bmProxy.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.bmProxy)), NChangedWinThreshold_1.NChangedWinThreshold.schema.bmProxyOld.valueOf(ConverterUtils_1.ConverterUtils.toBigNumberOrNull(conversions, source.bmProxyOld)), NChangedWinThreshold_1.NChangedWinThreshold.schema.bmProxyAbsTh.valueOf(source.bmProxyAbsTh), NChangedWinThreshold_1.NChangedWinThreshold.schema.bmProxyRelTh.valueOf(source.bmProxyRelTh));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        promoSales: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.promoSales),
        promoSalesOld: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.promoSalesOld),
        promoSalesAbsTh: source.promoSalesAbsTh,
        promoSalesRelTh: source.promoSalesRelTh,
        bmProxy: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.bmProxy),
        bmProxyOld: ConverterUtils_1.ConverterUtils.fromBigNumberOrNull(conversions, source.bmProxyOld),
        bmProxyAbsTh: source.bmProxyAbsTh,
        bmProxyRelTh: source.bmProxyRelTh
      });
      return result;
    }
  }]);

  return NChangedWinThresholdConverterImpl;
}(NChangedWinThresholdConverter_1.NChangedWinThresholdConverter);

exports.NChangedWinThresholdConverterImpl = NChangedWinThresholdConverterImpl;
/**
 * IOC Container qualifier
 */

NChangedWinThresholdConverterImpl.QUALIFIER = {
  documentType: NChangedWinThreshold_1.NChangedWinThreshold.name
};